import { all, takeLatest, fork, call, put } from "redux-saga/effects";
import actions from "./actions";
import { crawlBookingPositionService} from "@iso/services";
export function* crawlBookingPosition() {
    yield takeLatest(actions.CRAWL_BOOKING_POSITION_REQUEST, function* ({ payload }) {
        const {
            periodStart,
            periodEnd,
            bookingPositionDate,
            otas,
            resolve,
            reject
        } = payload;
        try {
            const response = yield call(crawlBookingPositionService.crawlBookingPosition, {
                periodStart,
                periodEnd,
                bookingPositionDate,
                otas,
                resolve,
                reject
            });
            yield put({
                type: actions.CRAWL_BOOKING_POSITION_SUCCESS,
                crawler: response,
            });
            yield resolve(response);
        } catch (e) {
            yield put({ type: actions.CRAWL_BOOKING_POSITION_ERROR });
            reject(e);
        }
    });
}
export function* getCrawlBookingPosition() {
    yield takeLatest(actions.GET_CRAWL_BOOKING_POSITION_REQUEST, function* () {
        try {
            const report = yield call(crawlBookingPositionService.getCrawlBookingPosition);
            yield put({
                type: actions.GET_CRAWL_BOOKING_POSITION_SUCCESS,
                crawler: report,
            });
        } catch (error) {
            yield put({
                type: actions.GET_CRAWL_BOOKING_POSITION_ERROR,
                error: error.response,
            });
        }
    });
}
export function* deleteInformationStore() {
    yield takeLatest(actions.DELETE_EXCEL_STORE_BOOKING_POSITION_REQUEST, function* ({ payload }) {
        const {
            resolve,
            reject
        } = payload;
        try {
            const response = yield call(crawlBookingPositionService.deleteInformationStore, {
                resolve,
                reject
            });
            yield put({
                type: actions.DELETE_EXCEL_BOOKING_POSITION_SUCCESS,
            });
            yield resolve(response);
        } catch (error) {
            yield put({
                type: actions.DELETE_EXCEL_BOOKING_POSITION_ERROR,
            });
            reject(error);
        }
    });
}
export function* getInformationStore() {
    yield takeLatest(actions.GET_EXCEL_BOOKING_POSITION_REQUEST, function* () {
        try {
            const response = yield call(crawlBookingPositionService.getInformationStore);
            yield put({
                type: actions.GET_EXCEL_BOOKING_POSITION_SUCCESS,
                isExistFile: response,
            });
        } catch (error) {
            yield put({
                type: actions.GET_EXCEL_BOOKING_POSITION_ERROR,
                isExistFile: false,
            });
        }
    });
}
export default function* rootSaga() {
    yield all([fork(crawlBookingPosition)]);
    yield all([fork(getCrawlBookingPosition)]);
    yield all([fork(deleteInformationStore)]);
    yield all([fork(getInformationStore)]);
}